import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { StrictMode, useState } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Auth } from "./components/Auth";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRoutes from "./components/AppRoutes";
import { LoadingSpinnerContext } from "./contexts/LoadingSpinnerContext";
import LoadingSpinner from "components/LoadingSpinner";
import { ManualPage } from "pages/ManualPage";
import { ContactPage } from "pages/ContactPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});

export const App = () => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const [isLoading, setIsLoading] = useState(false);

  if (authStatus === "configuring") return null;

  return (
    <StrictMode>
      <Router>
        <Routes>
          {/* 認証なしでアクセス可能なページ */}
          <Route path="/manual" element={<ManualPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* その他のページは認証状態に応じて表示 */}
          <Route
            path="*"
            element={
              authStatus !== "authenticated" ? (
                <Auth />
              ) : (
                <QueryClientProvider client={queryClient}>
                  <LoadingSpinnerContext.Provider
                    value={{ isLoading, setIsLoading }}
                  >
                    <AppRoutes />
                    <LoadingSpinner />
                  </LoadingSpinnerContext.Provider>
                </QueryClientProvider>
              )
            }
          />
        </Routes>
      </Router>
    </StrictMode>
  );
};
